<template>
    <span class="yushu-upload-avator" :class="[size, circle? 'circle' : '']" :style="styles">
        <el-upload ref="upload" :headers="uploadHeaders" :with-credentials="true" :action="imageActionUrl" :limit="1" :show-file-list="false" :before-upload="onBeforeUploadFile" :on-success="onUploadSuccess" :on-remove="onRemoveFile" :on-error="onUploadError" :accept="Constants.UploadFileType.PICTURE">
            <img v-if="url" :src="url" style="max-width:100%">
            <i v-else class="el-icon-plus"></i>
        </el-upload>
    </span>
</template>
<script>
import { getToken } from '@/web-framework/api/token';
import UserAPI from "@/web-framework/api/user.js";
export default {
    name: "YushuUploadImage",
    props: {
        autoUpload: {
            type: Boolean,
            default: true
        },
        onChange: {
            type: Function,
            default: () => {
                return;
            }
        },
        beforeUpload: {
            type: Function,
            default: () => {
                return true;
            }
        },
        afterUpload: {
            type: Function,
            default: () => {
            }
        },
        showStyle: {
            type: String,
            default: () => {
                return 'button'
            }
        },
        maxSize: {
            type: Number,
            default: 5
        },
        size: {
            type: String,
            default: 'w100' // w120- 120宽度  w-140 140宽度
        },
        styles: {
            type: String,
            default: ''
        },
        bean: {
            type: Object
        },
        property: {
            type: String
        },
        circle: {
            type: Boolean,
            default: true
        },
        uploadParams: {
            type: String,
            default: ''
        }
    },
    watch: {
        bean: {
            deep: true,
            handler(val) {
                if (val) {
                    if (val[this.property]) {
                        let fullUrl = this.Utils.getResourceUrl(val[this.property]);
                        Vue.set(this, 'url', fullUrl);
                    }
                }
            }
        },
        uploadParams(val) {
            if (val) {
                this.uploadParams = val;
                Vue.set(this, 'imageActionUrl', '/api/storage/resources/upload?avator=false&' + this.uploadParams);
            }
        }
    },
    data() {
        return {
            loading: false,
            url: '',
            uploadHeaders: {
                authorization: getToken(),
                'model': this.$route.name,
            },
            imageActionUrl: '/api/storage/resources/upload?avator=false&' + this.uploadParams,
        }
    },
    mounted() {
        if (this.bean && this.bean[this.property]) {
            let fullUrl = this.Utils.getResourceUrl(this.bean[this.property]);
            Vue.set(this, 'url', fullUrl);
        }
    },
    methods: {
        onBeforeUploadFile(file) {
            this.loading = true;

            if (this.Utils.checkFileSize(file, this.maxSize * 1024 * 1024) > 0) {
                this.$message.error(`图片最大不能超过${this.maxSize}MB，请裁剪后重新上传！`);
                return false;
            }

            return this.beforeUpload();
        },
        //文件状态改变
        onChangeFile(file, fileList) {
            if (this.onChange) {
                this.onChange(file, this.fileList);
            }
        },
        onRemoveFile(file, fileList) {
            this.$refs.upload.clearFiles();
        },
        onUploadError(response, file, fileList) {
            this.loading = false;
            this.$refs.upload.clearFiles();
        },
        submit() {
            if (this.$refs.upload) {
                this.$refs.upload.submit();
            }
        },
        onUploadSuccess(fileInfo) {
            this.loading = false;
            if (!fileInfo.success) {
                if (fileInfo.message) {
                    this.$message.error(fileInfo.message);
                }
                this.$refs.upload.clearFiles();
                return;
            }

            if (this.afterUpload) {
                this.afterUpload(fileInfo.data);
            }
            this.url = this.Utils.getResourceUrl(fileInfo.data.url);
            this.$refs.upload.clearFiles();
        },
    }
}
</script>